module.exports = __webpack_public_path__ + "img/symbol_6.49142257.png";